import dateFormat from "dateformat";

//EXCEL
import * as FileSaver from "file-saver";
import XLSX from "tempa-xlsx";
import { strToArrBuffer, excelSheetFromDataSet } from "../../../utilities/dataHelpers";

export const excelRPT215 = (dataReport) => {
    let newData = dataModifyToExcel(dataReport);
    let setBorder = {
        left: {
            style: "thin",
            color: {
                auto: 1,
            },
        },
        right: {
            style: "thin",
            color: {
                auto: 1,
            },
        },
        top: {
            style: "thin",
            color: {
                auto: 1,
            },
        },
        bottom: {
            style: "thin",
            color: {
                auto: 1,
            },
        },
    };
    let styleTextHeaders = {
        fill: {
            fgColor: { rgb: "c7c7c7" },
        },
        font: { bold: true },
        alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
        },
        border: setBorder,
    };
    let styleHeaders = {
        fill: {
            fgColor: { rgb: "c7c7c7" },
        },
        font: { bold: true },
        alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
        },
        border: setBorder,
    };
    let styleBorderB = {
        fill: {
            fgColor: { rgb: "ffffff" },
        },
        border: setBorder,
        alignment: {
            vertical: "center",
            wrapText: true,
        },
    };
    let styleSummaryHeaders = {
        fill: {
            fgColor: { rgb: "ffd966" },
        },
        font: { bold: true },
        alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
        },
        border: setBorder,
    };
    let styleSummary = {
        fill: {
            fgColor: { rgb: "ffd966" },
        },
        font: { bold: true },
        alignment: {
            horizontal: "right",
            vertical: "center",
            wrapText: true,
        },
        border: setBorder,
    };

    if (newData && newData.length > 0) {
        let dataRow = newData;
        let dataExcel = [];
        let headerText = [
            {
                text: "บันทึกผลฯ-เส้นทาง",
                style: styleTextHeaders,
            },
            {},
        ];

        //หัวรายงาน
        for (let i = 0; i < headerText.length; i++) {
            dataExcel.push([{ value: headerText[i].text, style: headerText[i].style }]);
        }

        // ADD Row
        for (let i = 0; i < dataRow.length; i++) {
            //dataExcel
            let dataRowTmp = [];
            if (i === dataRow.length - 1) {
                dataRowTmp.push(
                    { value: dataRow[i].col1 ? dataRow[i].col1 : "", style: styleSummary },
                    { value: dataRow[i].col2 ? dataRow[i].col2 : "", style: styleSummaryHeaders },
                    { value: dataRow[i].col3 ? dataRow[i].col3 : "", style: styleSummary },
                    { value: dataRow[i].col4 ? dataRow[i].col4 : "", style: styleSummary },
                    { value: dataRow[i].col5 ? dataRow[i].col5 : "", style: styleSummary },
                    { value: dataRow[i].col6 ? dataRow[i].col6 : "", style: styleSummary },
                    { value: dataRow[i].col7 ? dataRow[i].col7 : "", style: styleSummary },
                    { value: dataRow[i].col8 ? dataRow[i].col8 : "", style: styleSummary },
                    { value: dataRow[i].col9 ? dataRow[i].col9 : "", style: styleSummary },
                    { value: dataRow[i].col10 ? dataRow[i].col10 : "", style: styleSummary },
                    { value: dataRow[i].col11 ? dataRow[i].col11 : "", style: styleSummary },
                    { value: dataRow[i].col12 ? dataRow[i].col12 : "", style: styleSummary },
                    { value: dataRow[i].col13 ? dataRow[i].col13 : "", style: styleSummary },
                    { value: dataRow[i].col14 ? dataRow[i].col14 : "", style: styleSummary },
                    { value: dataRow[i].col15 ? dataRow[i].col15 : "", style: styleSummary } // new
                );
            } else {
                dataRowTmp.push(
                    { value: dataRow[i].col1 ? dataRow[i].col1 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col2 ? dataRow[i].col2 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col3 ? dataRow[i].col3 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col4 ? dataRow[i].col4 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col5 ? dataRow[i].col5 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col6 ? dataRow[i].col6 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col7 ? dataRow[i].col7 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col8 ? dataRow[i].col8 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col9 ? dataRow[i].col9 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col10 ? dataRow[i].col10 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col11 ? dataRow[i].col11 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col12 ? dataRow[i].col12 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col13 ? dataRow[i].col13 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col14 ? dataRow[i].col14 : "", style: i < 2 ? styleHeaders : styleBorderB },
                    { value: dataRow[i].col15 ? dataRow[i].col15 : "", style: i < 2 ? styleHeaders : styleBorderB } // new
                );
            }

            dataExcel.push(dataRowTmp);
        }
        //"xlsx"  "csv"
        exportFile(dataExcel);
        // this.handleCloseExport()
    } else {
        alert("เกิดข้อผิดพลาด : ไม่พบข้อมูลส่งออก");
        // showMessages(toast,'warn', `เกิดข้อผิดพลาด`, 'ไม่พบข้อมูลส่งออก');
    }
};

const exportFile = (dataExcel) => {
    let filename = "RPT215_" + dateFormat(new Date(), "yyyymmdd");

    let mergesData = [
        { s: { r: 0, c: 0 }, e: { r: 1, c: 14 } },
        { s: { r: 2, c: 0 }, e: { r: 3, c: 0 } }, //1
        { s: { r: 2, c: 1 }, e: { r: 3, c: 1 } },
        { s: { r: 2, c: 2 }, e: { r: 3, c: 2 } },
        { s: { r: 2, c: 3 }, e: { r: 3, c: 3 } },
        { s: { r: 2, c: 4 }, e: { r: 3, c: 4 } },
        { s: { r: 2, c: 5 }, e: { r: 3, c: 5 } }, //6
        { s: { r: 2, c: 6 }, e: { r: 3, c: 6 } },
        { s: { r: 2, c: 7 }, e: { r: 3, c: 7 } },
        { s: { r: 2, c: 8 }, e: { r: 3, c: 8 } },
        { s: { r: 2, c: 9 }, e: { r: 3, c: 9 } },
        { s: { r: 2, c: 10 }, e: { r: 3, c: 10 } },
        { s: { r: 2, c: 11 }, e: { r: 3, c: 11 } },
        { s: { r: 2, c: 12 }, e: { r: 3, c: 12 } },
        { s: { r: 2, c: 13 }, e: { r: 2, c: 14 } },
    ];

    const wb = {
        SheetNames: [filename],
        Sheets: {
            [filename]: excelSheetFromDataSet([
                {
                    columns: null,
                    data: dataExcel,
                    merges: mergesData,
                    page: "RPT215",
                },
            ]),
        },
    };
    const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "binary" });
    let data = new Blob([strToArrBuffer(wbout)], { type: "application/octet-stream" });
    FileSaver.saveAs(data, filename + "." + "xlsx");
    // setLoading(false)
};

const dataModifyToExcel = (data) => {
    let dataReport = [];
    if (data && data !== undefined && data.length > 0) {
        let temp = [];
        data.forEach((item, index) => {
            let _item = {};
            for (let key in item) {
                // console.log();
                switch (key) {
                    case "itemSeq": {
                        _item["col1"] = item[key];
                        break;
                    }
                    case "itemDesc": {
                        _item["col2"] = item[key];
                        break;
                    }
                    case "itemUnitDesc": {
                        _item["col3"] = item[key];
                        break;
                    }
                    case "itemUnitPrice": {
                        _item["col4"] = item[key];
                        break;
                    }
                    case "totalResult": {
                        _item["col5"] = item[key];
                        break;
                    }
                    case "resultDay7Unit": {
                        _item["col6"] = item[key];
                        break;
                    }
                    case "resultDay6Unit": {
                        _item["col7"] = item[key];
                        break;
                    }
                    case "resultDay5Unit": {
                        _item["col8"] = item[key];
                        break;
                    }
                    case "resultDay4Unit": {
                        _item["col9"] = item[key];
                        break;
                    }
                    case "resultDay3Unit": {
                        _item["col10"] = item[key];
                        break;
                    }
                    case "resultDay2Unit": {
                        _item["col11"] = item[key];
                        break;
                    }
                    case "resultDay1Unit": {
                        _item["col12"] = item[key];
                        break;
                    }
                    case "resultTodayUnit": {
                        _item["col13"] = item[key];
                        break;
                    }
                    case "unitAll": {
                        _item["col14"] = item[key];
                        break;
                    }
                    case "priceAll": {
                        _item["col15"] = item[key];
                        break;
                    }
                }
            }

            temp.push(_item);
        });

        dataReport = [...temp];
    }

    return dataReport;
};
